// @ts-ignore
import type {IOrderFalseDriverState} from "@/store/states/IOrderFalseDriverState.interface";
// @ts-ignore
import {RentComponentErrorMessages} from "../interfaces/enums/RentComponentErrorMessages.enum";

const orderFalseDriver = {
    prefix: 'falseDriver.',
    namespaced: true,
    state: <IOrderFalseDriverState>{
        id: null,
        isRentFormValid: true,
        messages: {
            validTime: {
                state: true,
                message: RentComponentErrorMessages.MESSAGE_TIME
            },
            validDate: {
                state: true,
                message: RentComponentErrorMessages.MESSAGE_DATE
            },
            validLocation: {
                state: true,
                message: RentComponentErrorMessages.MESSAGE_LOCATION
            },
        },
        passengerCount: null,
        pickupTime: null,
        pickupDate: null,
        endTime: null,
        endDate: null,
        destination: null,
        formatted_address: null,
        place_id: null,
        url: null
    },
    mutations: {
        INITIALIZE_FALSE_DRIVER_ORDER_STATE(state: IOrderFalseDriverState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {

                let value = localStorage.getItem(orderFalseDriver.prefix + prop);

                if (value) {
                    value = JSON.parse(value);

                    switch (prop) {
                        case 'pickupDate':
                        case 'endDate':
                            // @ts-ignore
                            value = new Date(value);
                            break;
                    }

                    state[prop] = value;
                }
            }
        },
        SET_STATE_PROP_VALUE(state: IOrderFalseDriverState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                let value = obj.value;

                // Ensure props to be converted to object accordingly
                switch (prop) {
                    case 'pickupDate':
                    case 'endDate':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value = new Date(value);
                        }
                        break;
                }

                state[prop] = value;

                localStorage.removeItem(orderFalseDriver.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(orderFalseDriver.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },
        CLEAR_STATE(state: IOrderFalseDriverState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(orderFalseDriver.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },
    actions: {
        updateState(context, data: {prop: string, value: any}): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },
    },
    getters: {

    }
}

export default orderFalseDriver;